export const SCHOOL_NAME = 'SHREE MAHARAJA ENGLISH MEDIUM PUBLIC SCHOOL KAMANAKERI';
export const SCHOOL_NAME_HTML = 'SHREE MAHARAJA ENGLISH<br>MEDIUM PUBLIC SCHOOL KAMANAKERI';
export const SCHOOL_SHORT_NAME = 'Shree Maharaja';
export const SCHOOL_ADDRESS = 'KAMANAKERI - 585 314 - Tq. Aland Dist. Kalaburagi';
export const SCHOOL_ADDRESS_SHORT = 'Kamanakeri - 585314, Tq. Aland, Dist. Kalaburagi';
export const LOGO_PATH = '/school-logo.jpeg';
